$(document).ready(function () {
  console.log("Product script loaded ✅");

  (function (bodyScrollLock, themeCurrency, Flickity, FlickityFade, Ajaxinate, FlickityAsNavFor, Rellax) {

    // Safe formatter
    const formatMoney = (amount) => {
      try {
        return themeCurrency.formatMoney(amount, theme.moneyWithoutCurrencyFormat);
      } catch (e) {
        console.warn("Fallback formatter used");
        return `£${(amount / 100).toFixed(2)}`;
      }
    };

    // One-Time Purchase
    $(document).on('click', '.oneTimePurchase', function () {
      console.log("Clicked One-Time");
      $('.product__form-block .qty__adjust').removeClass("hidden");
      $("input[name='selling_plan']").val('');

      const price = $(this).data("product-price");
      const priceMoney = $(this).data("price-money");

      const formatted = formatMoney(price);
      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);      

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', 1).val("1");
      $(".qty__adjust-btn--minus").prop("disabled", false);
      
      $("#main_atc_text .discounted_price").remove();
      $("#main_atc_text").removeClass('discount_price_added');
    });


    // Bulk Buy Purchase
    $(document).on('click', '.singlefrequencySelector.bulkBuyPurchase', function () {
      $('.product__form-block .qty__adjust').addClass("hidden");

      $("input[name='selling_plan']").val('');
      let sellingQty = parseInt($(this).data("product-quantity"));

      const price = parseInt($(this).data("selling-price"));
      const priceMoney = parseInt($(this).data("price-money"));
      
      const discountPrice = parseInt($(this).data("discount-price"));
      const finalPrice = parseInt($(this).data("final-price"));

      // let productDiscount = $(this).data("product-discount");      

      //let qty = sellingQty;
      const total = price * sellingQty;
      const discountTotal = total - discountPrice;
      const formatted = formatMoney(total);      

      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);

      const discountedSpan = document.createElement('span');
      discountedSpan.classList.add('discounted_price');
      discountedSpan.textContent = `£${Number(finalPrice).toFixed(2)}` // your discounted price value 
      $("#main_atc_text").append(discountedSpan); 
      
      $("#main_atc_text").addClass('discount_price_added');


      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', sellingQty);
      $(".qty__adjust-input").val(sellingQty);
      $(".qty__adjust-btn--minus").prop("disabled", false);

      // $('.product__form-submit').attr('data-discount-code', productDiscount);  

      console.log("Selling Qty =>", sellingQty);
    });


    // 14-Day Subscription
    $(document).on('click', '.subAndSave.subOption1', function () {
      console.log("Clicked 14-day subscription");
      $('.product__form-block .qty__adjust').addClass("hidden");

      const sellingId = $(this).data("selling-id");
      let sellingQty = parseInt($(this).data("selling-qty"));

      $("input[name='selling_plan']").val(sellingId);

      const price = $(this).data("selling-price");
      const priceMoney = $(this).data("price-money");

      let qty = sellingQty;
      const total = price * qty;
      const formatted = formatMoney(total);      

      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', qty);
      $(".qty__adjust-input").val(qty);
      $(".qty__adjust-btn--minus").prop("disabled", false);
      console.log("Selling Qty =>", qty);

      $("#main_atc_text .discounted_price").remove();
      $("#main_atc_text").removeClass('discount_price_added');
    });

    // 28-Day Subscription (simulated)
    $(document).on('click', '.subAndSave.subOption2', function () {
      console.log("Clicked 28-day (qty 2)");
      $('.product__form-block .qty__adjust').addClass("hidden");

      const sellingId = $(this).data("selling-id");
      let sellingQty = parseInt($(this).data("selling-qty"));

      $("input[name='selling_plan']").val(sellingId);

      const price = $(this).data("selling-price");
      const priceMoney = $(this).data("price-money");

      let qty = sellingQty;
      const total = price * qty;
      const formatted = formatMoney(total);      

      $("#variant_price").text(formatted).attr("data-price-money", priceMoney);

      $(".singlefrequencySelector").removeClass("active");
      $(this).addClass("active");

      $(".qty__adjust-input").prop('min', qty);
      $(".qty__adjust-input").val(qty);
      $(".qty__adjust-btn--minus").prop("disabled", true);
      console.log("Selling Qty =>", qty);

      $("#main_atc_text .discounted_price").remove();
      $("#main_atc_text").removeClass('discount_price_added');
    });

    // Quantity change
    $(document).on('change', '.qty__adjust-input', function () {
      const qty = parseInt($(this).val()) || 1;
      // const is28 = $(".subAndSave.subOption2.active").length > 0;

      // if (is28 && qty < 2) {
      //   $(this).val(2);
      //   $(".qty__adjust-btn--minus").prop("disabled", true);
      //   return;
      // }

      const unitPrice = $("#variant_price").data("price-money");
      const formatted = formatMoney(unitPrice * qty);
      $("#variant_price").text(formatted);
    });

    // Quantity +/- button click
    $(document).on('click', '.qty__adjust-btn', function () {
      const qty = parseInt($(".qty__adjust-input").val()) || 1;
      // const is28 = $(".subAndSave.subOption2.active").length > 0;

      // if (is28 && qty <= 2) {
      //   $(".qty__adjust-btn--minus").prop("disabled", true);
      // }

      const unitPrice = $("#variant_price").data("price-money");
      const formatted = formatMoney(unitPrice * qty);
      $("#variant_price").text(formatted);
    });

    // Meta Pixel params to cart
    const form = document.querySelector('form[action^="/cart"]');
    if (form) {
      const fbp = document.cookie.split('; ').find(row => row.startsWith('_fbp='))?.split('=')[1] || '';
      const fbc = document.cookie.split('; ').find(row => row.startsWith('_fbc='))?.split('=')[1] || '';

      if (fbp) {
        const fbpInput = document.createElement('input');
        fbpInput.type = 'hidden';
        fbpInput.name = 'attributes[_fbp]';
        fbpInput.value = fbp;
        form.appendChild(fbpInput);
      }

      if (fbc) {
        const fbcInput = document.createElement('input');
        fbcInput.type = 'hidden';
        fbcInput.name = 'attributes[_fbc]';
        fbcInput.value = fbc;
        form.appendChild(fbcInput);
      }
    }

  }(
    themeVendor.BodyScrollLock,
    themeVendor.themeCurrency,
    themeVendor.Flickity,
    themeVendor.FlickityFade,
    themeVendor.ajaxinate,
    themeVendor.FlickityAsNavFor,
    themeVendor.Rellax
  ));
});
